import React, {Component, Fragment} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import {hot} from 'react-hot-loader';
import {BrowserRouter} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import ScrollToTop from './ScrollToTop';
import {connect} from 'react-redux';
import {Blogs} from '../../services/Blogs';
import {setBlogs, initCurrentBlog} from '../../redux/actions/blogsActions';
import {welcomeModalOpen} from '../../redux/actions/modalsActions';
import {fetchDrafts} from '../../redux/actions/draftsActions';
import {fetchPosts} from '../../redux/actions/postsActions';
import {fetchAccountStats} from '../../redux/actions/steemAccountActions';
import {authSuccess} from '../../redux/actions/authActions';
import {changeThemeToDark, changeThemeToLight} from '../../redux/actions/themeActions';
import {fetchDomains} from '../../redux/actions/domainsActions';
import { I18nextProvider } from 'react-i18next';

import i18next from '../../translations/i18n';

class App extends Component {

    constructor() {
        super();
        this.state = {
            loading: true,
        };
    }

    componentDidMount = async () => {

        const dashboard_theme = localStorage.getItem('dashboard-theme');
        const storedBlog = localStorage.getItem('blog');

        switch (dashboard_theme) {
            case 'theme-dark':
                this.props.changeThemeToDark();
                break;
            default:
            case 'theme-light':
                this.props.changeThemeToLight();
                break;
        }

        if (!this.props.auth.authenticated) {
            const jwt = localStorage.getItem('jwt');
            if (jwt) {
                this.props.onAuthentication(jwt);
                try {
                    const blogs = await Blogs.getBlogs();

                    this.props.onSetBlogs(blogs);

                    if (blogs && blogs.length) {

                        let blogIdToInitialize = blogs[0]._id;

                        if (blogs.find(blog => blog._id === storedBlog)) {
                            blogIdToInitialize = storedBlog;
                        }
                        console.log(blogIdToInitialize);

                        this.props.initCurrentBlog(blogIdToInitialize);
                        this.props.fetchDrafts(blogIdToInitialize);
                        this.props.fetchPosts(blogIdToInitialize);
                    } else {
                        console.log("No blogs!");
                        setTimeout(() => {
                            this.props.openWelcomeModal()
                        }, 500);
                    }

                    this.props.fetchAccountStats(this.props.auth.username);
                    this.props.fetchDomains();
                    setInterval(() => {
                        this.props.fetchAccountStats(this.props.auth.username)
                    }, 1 * 60 * 1000);
                } catch (error) {
                    console.log(error);
                }
            } else {
                console.log('Should redirect to /login if not in /login');
            }
        }
    }

    render() {
        const {loading} = this.state;
        const {loaded} = this.props;

        return (
            <BrowserRouter>
                <I18nextProvider i18n={i18next}>
                    <ScrollToTop>
                        <Fragment>
                            {!loaded
                            && (
                                <div className={`load${loading ? '' : ' loaded'}`}>
                                    <div className="load__icon-wrap">
                                        <svg className="load__icon">
                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                                        </svg>
                                    </div>
                                </div>
                            )
                            }
                            <div>
                                <Router/>
                            </div>
                        </Fragment>
                    </ScrollToTop>
                </I18nextProvider>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blogs: state.blogs,
        theme: state.theme,
        auth: state.auth,
        loaded: true
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSetBlogs: (blogs) => dispatch(setBlogs(blogs)),
        initCurrentBlog: (blogId) => dispatch(initCurrentBlog(blogId)),
        fetchAccountStats: (username) => dispatch(fetchAccountStats(username)),
        fetchDrafts: (blogId) => dispatch(fetchDrafts(blogId)),
        fetchPosts: (blogId) => dispatch(fetchPosts(blogId)),
        fetchDomains: () => dispatch(fetchDomains()),
        openWelcomeModal: () => dispatch(welcomeModalOpen()),
        onAuthentication: (jwt) => dispatch(authSuccess(jwt)),
        changeThemeToDark: () => dispatch(changeThemeToDark()),
        changeThemeToLight: () => dispatch(changeThemeToLight())
    }
}

export default hot(module)(connect(mapStateToProps, mapDispatchToProps)(App));
